import React, { useEffect } from 'react'
import ReactGA from 'react-ga'
import { Route, Switch, useHistory } from 'react-router-dom'
import App from './App'
import HomePageKitDigital from './pages/external/HomeKitDigital'

import { initHotjar } from 'libs/hotjar'
import { initGA } from 'libs/ga'

const AppGlobal = () => {
  const history = useHistory()

  useEffect(() => {
    initHotjar()
    initGA()
    history.listen(location => {
      // console.log("tracking page view: " + location.pathname);
      ReactGA.pageview(location.pathname)
    })
  }, [history])

  return (
    <Switch>
      <Route path="/kitdigital" exact component={HomePageKitDigital} />
      <Route component={App} />
    </Switch>
  )
}

export default AppGlobal
